// For pathing-related operations on resources
//
// NOTE: LVGL versions in paths only require MAJOR.MINOR

import { joinFsPath } from '../../../utils/path';

//
export class ResourceManager {
    static isOnlinePreviewBundledResource(filePath: string): boolean {
        const normalizedPath: string = filePath.replace(/\\/g, '/');
        return normalizedPath.includes('resources/templates') || normalizedPath.match(/resources\/v\d+\.\d+/) !== null;
    }

    static isLvglXmlSchemasPath(filePath: string): boolean {
        const normalizedPath: string = filePath.replace(/\\/g, '/');
        return normalizedPath.match(/resources\/v\d+\.\d+(?:.\d+)?\/(?:xml|lv_xml\/xmls)/) !== null;
    }

    static getXmlSchemasPath(baseResourcesPath: string, lvglVersion: string): string {
        return joinFsPath(baseResourcesPath, lvglVersion, 'xml', 'widgets');
    }

    static getLvglVersionFromResourcesPath(filePath: string): string | null {
        const match: RegExpMatchArray | null = filePath.match(/resources\/(v\d+\.\d+\.?(\d+)?)/);
        if (!match) {
            return null;
        } else {
            return match[1];
        }
    }

    static getComponentLibraryPath(resourcesSrcPath: string, lvglVersion: string, libraryName: string): string {
        return joinFsPath(resourcesSrcPath, lvglVersion, 'xml', 'component_libs', libraryName);
    }
}
